import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useContent } from '../lib/content';
import { SEO } from '../components/SEO';
import { Button } from '../components/ui/button';

export default function About() {
  const { about } = useContent();

  return (
    <>
      <SEO
        title="About Us"
        description="Higgins Truck Sales is part of Higgins Services, a trusted name in the transport and logistics industry. Quality trucks and trailers at competitive prices."
        path="/about"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="rounded-xl overflow-hidden aspect-[4/3]">
            <img src={about.image_url} alt="Higgins truck" className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-wider text-[#24135F] leading-[0.95]">
              ABOUT HIGGINS
              <br />
              TRUCK SALES
            </h1>
            <p className="mt-6 text-[#53565A] leading-relaxed">{about.paragraph1}</p>
            <p className="mt-4 text-[#53565A] leading-relaxed">{about.paragraph2}</p>
            <ul className="mt-6 space-y-3">
              {(about.bullets || []).map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm font-medium text-[#24135F]">
                  <span className="h-6 w-6 rounded-full bg-[#E4002B]/10 flex items-center justify-center shrink-0">
                    <Check className="h-3.5 w-3.5 text-[#E4002B]" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
            <Button
              asChild
              data-testid="about-contact-button"
              className="mt-8 rounded-full bg-[#E4002B] text-white hover:bg-[#E4002B]/90 h-12 px-8 text-sm font-bold tracking-wider transition-colors duration-150"
            >
              <Link to="/contact">CONTACT US TODAY</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
